import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

const useGoogleAdsPageView = () => {
    const location = useLocation();

    useEffect(() => {
        try {
            if (typeof (window as any).gtag === 'function') {
                // Send page_view event for URL-based audience building (retargeting)
                // This allows creating audiences based on URL patterns (e.g., /webinar/2*, /szkolenie, etc.)
                (window as any).gtag('event', 'page_view', {
                    'page_path': location.pathname,
                    'page_location': window.location.href
                });

                // Track PageView conversion event for Google Ads
                (window as any).gtag('event', 'conversion', {
                    'send_to': 'AW-16562613681/1xYBCPbY864ZELHb1dk9'
                });
            }
        } catch (error) {
        }

    }, [location.pathname]);
};

export default useGoogleAdsPageView;
